ixModuleRouting("impactx.favorites", {
    "/favorite": {
        template: "<ixa-favorite></ixa-favorite>",
        templateUrl: "modules/favorite/templates/favorite.html",
        controller: "FavoriteOverviewCtrl",
        controllerAs: "favoriteOverviewCtrl",
        process: "Favorite",
        workspace: "shop",
    },
});
